import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "battery",
  "use": "battery-usage",
  "viewBox": "0 0 130.83 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130.83 68\" id=\"battery\"><title>资源 23</title><g data-name=\"图层 2\"><path d=\"M10.88 57.12h87V10.88h-87zm113.7-34.54V11.42A11.79 11.79 0 0 0 112.61 0H12A11.79 11.79 0 0 0 0 11.42v45.43A11.74 11.74 0 0 0 12 68h100.88a11.79 11.79 0 0 0 12-11.42V45.15a5.81 5.81 0 0 0 6-5.71V28a6.22 6.22 0 0 0-6.3-5.42zm-6 5.71v28.29a5.81 5.81 0 0 1-6 5.71H12a5.81 5.81 0 0 1-6-5.71V11.42a5.81 5.81 0 0 1 6-5.71h100.88a5.81 5.81 0 0 1 6 5.71v16.87z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/battery.svg
// module id = q4P9
// module chunks = 6